/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ContactAddress,
    ContactAddressFromJSON,
    ContactAddressFromJSONTyped,
    ContactAddressToJSON,
} from './ContactAddress';
import {
    ContactObjectType,
    ContactObjectTypeFromJSON,
    ContactObjectTypeFromJSONTyped,
    ContactObjectTypeToJSON,
} from './ContactObjectType';
import {
    ContactSpendData,
    ContactSpendDataFromJSON,
    ContactSpendDataFromJSONTyped,
    ContactSpendDataToJSON,
} from './ContactSpendData';
import {
    FileObject,
    FileObjectFromJSON,
    FileObjectFromJSONTyped,
    FileObjectToJSON,
} from './FileObject';
import {
    MarketingUnsubscribeReason,
    MarketingUnsubscribeReasonFromJSON,
    MarketingUnsubscribeReasonFromJSONTyped,
    MarketingUnsubscribeReasonToJSON,
} from './MarketingUnsubscribeReason';
import {
    PaymentSource,
    PaymentSourceFromJSON,
    PaymentSourceFromJSONTyped,
    PaymentSourceToJSON,
} from './PaymentSource';
import {
    PayoutProvider,
    PayoutProviderFromJSON,
    PayoutProviderFromJSONTyped,
    PayoutProviderToJSON,
} from './PayoutProvider';

/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    id: string;
    /**
     * 
     * @type {ContactObjectType}
     * @memberof Contact
     */
    object: ContactObjectType;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    customer_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    user_id?: string;
    /**
     * 
     * @type {any}
     * @memberof Contact
     */
    program: any;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    picture_url?: string;
    /**
     * 
     * @type {FileObject}
     * @memberof Contact
     */
    picture?: FileObject;
    /**
     * 
     * @type {Array<ContactAddress>}
     * @memberof Contact
     */
    addresses: Array<ContactAddress>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Contact
     */
    phones: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    notes: string;
    /**
     * 
     * @type {any}
     * @memberof Contact
     */
    properties: any;
    /**
     * 
     * @type {PayoutProvider}
     * @memberof Contact
     */
    payment_provider?: PayoutProvider;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    payment_provider_id?: string;
    /**
     * 
     * @type {any}
     * @memberof Contact
     */
    default_source?: any;
    /**
     * 
     * @type {Array<PaymentSource>}
     * @memberof Contact
     */
    sources?: Array<PaymentSource>;
    /**
     * 
     * @type {boolean}
     * @memberof Contact
     */
    is_email_verified: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Contact
     */
    is_archived: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Contact
     */
    is_subscribed: boolean;
    /**
     * 
     * @type {MarketingUnsubscribeReason}
     * @memberof Contact
     */
    unsubscribe_reason?: MarketingUnsubscribeReason;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    unsubscribe_reason_other?: string;
    /**
     * 
     * @type {ContactSpendData}
     * @memberof Contact
     */
    spend_data: ContactSpendData;
    /**
     * 
     * @type {number}
     * @memberof Contact
     */
    num_relations: number;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    timezone: string;
    /**
     * 
     * @type {Date}
     * @memberof Contact
     */
    last_login?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Contact
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof Contact
     */
    updated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Contact
     */
    unsubscribed?: Date;
}

export function ContactFromJSON(json: any): Contact {
    return ContactFromJSONTyped(json, false);
}

export function ContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): Contact {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': ContactObjectTypeFromJSON(json['object']),
        'customer_id': !exists(json, 'customer_id') ? undefined : json['customer_id'],
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'program': json['program'],
        'first_name': json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'email': json['email'],
        'picture_url': !exists(json, 'picture_url') ? undefined : json['picture_url'],
        'picture': !exists(json, 'picture') ? undefined : FileObjectFromJSON(json['picture']),
        'addresses': ((json['addresses'] as Array<any>).map(ContactAddressFromJSON)),
        'phones': json['phones'],
        'notes': json['notes'],
        'properties': json['properties'],
        'payment_provider': !exists(json, 'payment_provider') ? undefined : PayoutProviderFromJSON(json['payment_provider']),
        'payment_provider_id': !exists(json, 'payment_provider_id') ? undefined : json['payment_provider_id'],
        'default_source': !exists(json, 'default_source') ? undefined : json['default_source'],
        'sources': !exists(json, 'sources') ? undefined : ((json['sources'] as Array<any>).map(PaymentSourceFromJSON)),
        'is_email_verified': json['is_email_verified'],
        'is_archived': json['is_archived'],
        'is_subscribed': json['is_subscribed'],
        'unsubscribe_reason': !exists(json, 'unsubscribe_reason') ? undefined : MarketingUnsubscribeReasonFromJSON(json['unsubscribe_reason']),
        'unsubscribe_reason_other': !exists(json, 'unsubscribe_reason_other') ? undefined : json['unsubscribe_reason_other'],
        'spend_data': ContactSpendDataFromJSON(json['spend_data']),
        'num_relations': json['num_relations'],
        'timezone': json['timezone'],
        'last_login': !exists(json, 'last_login') ? undefined : (new Date(json['last_login'])),
        'created': (new Date(json['created'])),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'unsubscribed': !exists(json, 'unsubscribed') ? undefined : (new Date(json['unsubscribed'])),
    };
}

export function ContactToJSON(value?: Contact | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': ContactObjectTypeToJSON(value.object),
        'customer_id': value.customer_id,
        'user_id': value.user_id,
        'program': value.program,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'email': value.email,
        'picture_url': value.picture_url,
        'picture': FileObjectToJSON(value.picture),
        'addresses': ((value.addresses as Array<any>).map(ContactAddressToJSON)),
        'phones': value.phones,
        'notes': value.notes,
        'properties': value.properties,
        'payment_provider': PayoutProviderToJSON(value.payment_provider),
        'payment_provider_id': value.payment_provider_id,
        'default_source': value.default_source,
        'sources': value.sources === undefined ? undefined : ((value.sources as Array<any>).map(PaymentSourceToJSON)),
        'is_email_verified': value.is_email_verified,
        'is_archived': value.is_archived,
        'is_subscribed': value.is_subscribed,
        'unsubscribe_reason': MarketingUnsubscribeReasonToJSON(value.unsubscribe_reason),
        'unsubscribe_reason_other': value.unsubscribe_reason_other,
        'spend_data': ContactSpendDataToJSON(value.spend_data),
        'num_relations': value.num_relations,
        'timezone': value.timezone,
        'last_login': value.last_login === undefined ? undefined : (value.last_login.toISOString()),
        'created': (value.created.toISOString()),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
        'unsubscribed': value.unsubscribed === undefined ? undefined : (value.unsubscribed.toISOString()),
    };
}

